/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BindingEnergy } from './BindingEnergy';
import {
    BindingEnergyFromJSON,
    BindingEnergyFromJSONTyped,
    BindingEnergyToJSON,
    BindingEnergyToJSONTyped,
} from './BindingEnergy';

/**
 * 
 * @export
 * @interface ResultInhibitor
 */
export interface ResultInhibitor {
    /**
     * 
     * @type {string}
     * @memberof ResultInhibitor
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResultInhibitor
     */
    zincId: string;
    /**
     * 
     * @type {string}
     * @memberof ResultInhibitor
     */
    zincIdShort: string;
    /**
     * 
     * @type {string}
     * @memberof ResultInhibitor
     */
    drugbankId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultInhibitor
     */
    name: string;
    /**
     * 
     * @type {BindingEnergy}
     * @memberof ResultInhibitor
     */
    bindingEnergy: BindingEnergy;
}

/**
 * Check if a given object implements the ResultInhibitor interface.
 */
export function instanceOfResultInhibitor(value: object): value is ResultInhibitor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('zincId' in value) || value['zincId'] === undefined) return false;
    if (!('zincIdShort' in value) || value['zincIdShort'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('bindingEnergy' in value) || value['bindingEnergy'] === undefined) return false;
    return true;
}

export function ResultInhibitorFromJSON(json: any): ResultInhibitor {
    return ResultInhibitorFromJSONTyped(json, false);
}

export function ResultInhibitorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultInhibitor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'zincId': json['zincId'],
        'zincIdShort': json['zincIdShort'],
        'drugbankId': json['drugbankId'] == null ? undefined : json['drugbankId'],
        'name': json['name'],
        'bindingEnergy': BindingEnergyFromJSON(json['bindingEnergy']),
    };
}

export function ResultInhibitorToJSON(json: any): ResultInhibitor {
    return ResultInhibitorToJSONTyped(json, false);
}

export function ResultInhibitorToJSONTyped(value?: ResultInhibitor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'zincId': value['zincId'],
        'zincIdShort': value['zincIdShort'],
        'drugbankId': value['drugbankId'],
        'name': value['name'],
        'bindingEnergy': BindingEnergyToJSON(value['bindingEnergy']),
    };
}

